import { MetricCard } from '../components/MetricCard';
import { DexVolumeChart } from '../components/DexVolumeChart';
import { DexTable } from '../components/DexTable';
import { useMockData } from '../hooks/useMockData';
import { useMemo } from 'react';

export default function Dex() {
  const { data, loading } = useMockData();
  
  const stats = useMemo(() => {
    if (!data) return null;
    
    const latestDate = Array.from(new Set(data.dex_volume.map(d => d.date))).sort().reverse()[0];
    const yesterdayDate = Array.from(new Set(data.dex_volume.map(d => d.date))).sort().reverse()[1];
    
    const todayData = data.dex_volume.filter(d => d.date === latestDate);
    const yesterdayData = data.dex_volume.filter(d => d.date === yesterdayDate);
    
    const totalVolume = todayData.reduce((sum, d) => sum + d.volume_usd, 0);
    const totalTrades = todayData.reduce((sum, d) => sum + d.trade_count, 0);
    
    const yesterdayVolume = yesterdayData.reduce((sum, d) => sum + d.volume_usd, 0);
    const yesterdayTrades = yesterdayData.reduce((sum, d) => sum + d.trade_count, 0);
    
    const volumeChange = ((totalVolume - yesterdayVolume) / yesterdayVolume) * 100;
    const tradesChange = ((totalTrades - yesterdayTrades) / yesterdayTrades) * 100;
    
    return {
      totalVolume,
      totalTrades,
      volumeChange,
      tradesChange,
      dexCount: todayData.length,
    };
  }, [data]);
  
  if (loading || !data || !stats) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg text-gray-600 dark:text-gray-400">Loading...</div>
      </div>
    );
  }
  
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">DEX Analytics</h1>
        <p className="text-gray-600 dark:text-gray-400">Decentralized exchange metrics and rankings</p>
      </div>
      
      {/* Key Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <MetricCard 
          title="Total Volume (24h)" 
          value={`$${(stats.totalVolume / 1000000).toFixed(2)}M`}
          change24h={stats.volumeChange}
        />
        <MetricCard 
          title="Total Trades (24h)" 
          value={stats.totalTrades.toLocaleString()}
          change24h={stats.tradesChange}
        />
        <MetricCard 
          title="Active DEXs" 
          value={stats.dexCount}
          subtitle="Trading on Worldchain"
        />
      </div>
      
      {/* DEX Volume Chart */}
      <div className="mb-8">
        <DexVolumeChart data={data.dex_volume} />
      </div>
      
      {/* DEX Rankings Table */}
      <div className="mb-8">
        <DexTable data={data.dex_volume} />
      </div>
    </div>
  );
}
